import { ACCENT, illustrationA11y, lineStyle } from './static-art';

export function TransactionApprovedIllustration(props: { className?: string; label?: string; ink?: string }) {
	const line = lineStyle(props.ink);
	return (
		<svg
			width="168"
			height="182"
			viewBox="0 0 168 182"
			fill="none"
			className={props.className}
			{...illustrationA11y(props.label)}
		>
			<path
				d="M27.6074 120.773C24.7221 123.171 21.5244 126.618 22.8397 130.125C23.2572 131.24 24.0924 132.141 24.9112 133.007C30.575 138.999 36.4739 144.772 42.5865 150.31C44.7534 152.273 47.1258 154.291 50.0243 154.703C54.7871 155.383 58.8923 151.598 62.2117 148.131C85.4867 123.813 99.6832 109.714 124.594 87.0586"
				{...line}
			/>
			<path
				d="M124.622 86.9956C130.113 79.0663 140.141 76.894 149 73.026C150.056 72.5643 151.296 71.7066 151.016 70.5918C150.843 69.906 150.15 69.5049 149.52 69.1792C141.589 65.0852 133.66 60.9912 125.729 56.8956C123.956 55.9805 122.16 55.0573 120.307 54.3125"
				{...line}
			/>
			<path
				d="M27.6582 120.747C51.9345 98.2407 65.9567 85.3155 90.2329 62.8092C94.3464 58.9951 105.748 45.9913 120.306 54.3102"
				{...line}
			/>
			<path
				d="M150.736 69.9609C154.558 72.8043 156.482 77.9901 156.411 82.7405C156.286 91.1986 152.634 99.5502 146.502 105.406C140.37 111.261 131.835 114.543 123.344 114.314"
				{...line}
			/>
			<path
				d="M22.5117 127.848C21.2178 129.953 21.3542 132.896 22.4788 135.094C23.6033 137.294 25.4332 139.039 27.2301 140.74C35.0345 148.128 42.8405 155.517 50.6449 162.904C53.254 165.373 56.2972 167.831 59.896 167.805C67.8369 167.748 71.268 162.662 73.8689 159.735"
				{...line}
			/>
			<path d="M73.9141 159.704C79.5121 155.243 113.529 123.338 123.325 114.297" {...line} />
			<path
				d="M76.0625 150.31C76.3157 147.305 75.0974 141.315 81.0588 134.708C91.982 122.602 94.795 119.735 107.259 109.205C108.099 108.495 108.962 107.778 109.978 107.354C111.157 106.863 112.462 106.795 113.735 106.689C117.947 106.334 122.096 105.463 126.233 104.594"
				{...line}
			/>
			<path d="M88.7637 64.6875C101.12 72.2125 113.762 80.0665 125.199 86.0332" {...line} />
			<path
				d="M32.2102 120.492L85.3119 71.1776C86.3936 70.1758 87.995 69.9679 89.3004 70.657L113.993 85.802C116.076 86.9036 116.47 89.711 114.77 91.3397L58.8737 145.035C57.565 146.288 55.5066 146.326 54.1536 145.12L32.2563 125.594C30.7355 124.239 30.7141 121.875 32.2086 120.492H32.2102Z"
				{...line}
			/>
			<path
				d="M91.5483 84.9118V25.7071C91.5483 19.4916 86.4878 14.4531 80.2453 14.4531H26.3068C20.0643 14.4531 15.0039 19.4916 15.0039 25.7071V84.9118C15.0039 91.1272 20.0643 96.1657 26.3068 96.1657H61.6131L78.33 107.511C79.1438 108.065 80.247 107.484 80.247 106.501V96.1657C86.4895 96.1657 91.5483 91.1273 91.5483 84.9134V84.9118Z"
				fill={ACCENT}
			/>
			<path
				d="M50.7486 72.4592C49.9677 72.5591 49.2246 72.2071 48.8053 71.5425C44.0951 64.0552 37.8131 59.3867 35.9997 58.1328C35.3388 57.6761 34.9738 56.8969 35.0462 56.0997C35.1234 55.2468 35.6002 53.7736 37.9233 53.4757C40.9533 53.0894 45.846 54.9178 47.5904 55.6233C56.659 41.5686 62.4297 35.8033 65.6882 33.4428C66.0812 33.158 66.5415 32.9763 67.0216 32.9141C67.8535 32.8077 68.6903 33.0663 69.315 33.6213L69.3414 33.6442C70.5234 34.7 70.6369 36.5154 69.5945 37.6956C56.9221 52.0564 53.4301 64.5905 52.4765 70.783C52.3401 71.6719 51.6446 72.3447 50.747 72.4592H50.7486Z"
				fill="white"
			/>
		</svg>
	);
}
